package com.iregained.site.components.sections.home.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val PrimaryBannerImageStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            // Resting state shadow
            .boxShadow(0.px, 20.px, 40.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.1f))
            // Smooth 0.5-second transition for a premium feel
            .transition(
                Transition.of("transform", 0.5.s),
                Transition.of("box-shadow", 0.5.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            // Subtle forward zoom
            .scale(1.02) 
            // Expands and darkens the Teal glow to make it pop
            .boxShadow(0.px, 30.px, 60.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.25f)) 
    }
}